import { FC, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { SCUIGeneralDrawerHeader } from '../../../../../atomic/molecules';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../../atomic/atoms';
import { BillingQuery } from '../../../../../services/query';
import { ReturnCommand } from '../../../../../services/command';
import Swal from 'sweetalert2';
import { fetchRejectedLabelAndUpdateStatus } from './SCUIReturnRejectDrawerContent.helpers';

export const SCUIReturnRejectDrawerContent: FC<{
    isMpRejectReturn?: any;
    selectedRejectedShippingID?: any;
    returnId?: any;
    onClose?: any;
    orderId?: any;
    customerId?: any;
    setRefresh?: any;
}> = ({ isMpRejectReturn, selectedRejectedShippingID, returnId, onClose, customerId, setRefresh }) => {
    const { t } = useTranslation();
    const [isPrintEnabled, setIsPrintEnabled] = useState<boolean>(false);
    const [isCreateEnabled, setIsCreateEnabled] = useState<boolean>(false);
    const [documentNo, setDocumentNo] = useState<any>(null);
    const GetDocumentNo = async () => {
        let params = { returnId: returnId, shipmentId: selectedRejectedShippingID };
        ReturnCommand.GetReturnDispatchDocumentNo(params).then((res: any) => {
            if (res.data.documentNo) {
                setDocumentNo(res.data.documentNo);
                setIsPrintEnabled(true);
                setIsCreateEnabled(false);
            }

            if (!res.data.documentNo) {
                setIsCreateEnabled(true);
                setIsPrintEnabled(false);
            }
        });
    };

    const label = (retryCount = 0) => {
        const maxRetry = 5;
        fetchRejectedLabelAndUpdateStatus(
            retryCount,
            maxRetry,
            { returnId, customerId, setRefresh, t },
            () => label(retryCount + 1)
        );
    };
    const createEInvoice = () => {
        let params = { returnId: returnId, shippingListId: selectedRejectedShippingID, IsLcwReturnDispatch: true };
        ReturnCommand.CreateDocument(params)
            .then((res: any) => {
                if (res.result) {
                    setIsPrintEnabled(true);
                    setIsCreateEnabled(false);
                } else {
                    Swal.fire('Error', t('general.invoiceCreationFailed'), 'error');
                    return;
                }
            })
            .then(() => {
                Swal.fire({
                    title: t('refund.processing'),
                    html: t('refund.dispatchNoteGenerating'),
                    timer: 6000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    willClose: () => {},
                });
            });
    };
    const printEInvoice = async () => {
        let params = {
            documentNo: documentNo,
            referenceId: selectedRejectedShippingID,
            customerId: customerId,
        };
        BillingQuery.GetEDispatch(params).catch((error: any) => {
            Swal.fire(t('refund.dispatchNoteError'), t('refund.errorQueue'), 'error');
            console.log('Hata :>> ', error);
        });
    };
    useEffect(() => {
        GetDocumentNo();
    }, []);
    return (
        <div className="commentFilterContainer">
            <Grid container spacing={2}>
                <SCUIGeneralDrawerHeader header={t('return.returnRejectionList')} onClose={onClose} />
                {!isMpRejectReturn && (
                    <>
                        <Grid
                            size={{
                                md: 12,
                                xs: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUIButton
                                type="primary"
                                size={'m'}
                                sizeType="fixed"
                                onClick={() => createEInvoice()}
                                text={t('refund.createInvoice')}
                                fullwidth
                                disabled={!isCreateEnabled}
                            />
                        </Grid>
                        <Grid
                            size={{
                                md: 12,
                                xs: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUIButton
                                type="primary"
                                disabled={!isPrintEnabled}
                                size={'m'}
                                sizeType="fixed"
                                onClick={() => printEInvoice()}
                                text={t('refund.printInvoice')}
                                fullwidth
                            />
                        </Grid>
                    </>
                )}
                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                        xl: 12,
                    }}
                ></Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUIButton
                        type="primary"
                        size={'m'}
                        sizeType="fixed"
                        onClick={() => label()}
                        text={t('general.printShippingLabel')}
                        fullwidth
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUIButton
                        type="primary"
                        size={'m'}
                        sizeType="fixed"
                        onClick={() => window.open('/returnRejectEntegration', '_blank')}
                        text={t('return.returnRejectOrders')}
                        fullwidth
                    />
                </Grid>
            </Grid>
        </div>
    );
};
